<template>
  <div class="graph-container">
    
    <!-- 组件栏 -->
    <div class="nodePanel">
      <NodesBar :nodes="nodes" :datajobNodes="datajobNodes" :datacollectNodes="datacollectNodes" :graph="graph"></NodesBar>
    </div>

    <div class="editPanel">
      <!-- 悬浮窗 tooltip -->
      <div id="tooltip-container">
        {{ tooltipsContent }}
      </div>

      <div class="dagCanvas">
        <!-- 工具栏 -->
        <div class="canvasToolbar">
          <Toolbar :graph="graph" />
        </div>
        <!-- 图形容器 -->
        <div id="container" class="canvasContent" />
      </div>

      <!-- 可操作区 -->
      <div class="right-bar">
        <PanelArea :type="type" :graph="graph" :node="node" :jobFlowInfo="jobFlowInfo" :collectJobList="collectJobList" :readonly="readonly" />
      </div>
    </div>
  </div>
</template>

<script>
import registerTools from "./tools/registerTools.js";
// import registerNode from "./shape/registerNode";
import { initGraph } from "./common/graph";
import NodesBar from "./components/NodesBar.vue";
import PanelArea from "./components/PanelArea.vue";
import Toolbar from "./components/Toolbar.vue";
import { nodes, datajobNodes, datacollectNodes } from "./common/nodesBar";
import { Config, CustomEventTypeEnum } from "./common/enums.js";
import { Channel } from "./common/transmit.js";
import { freezeGraph, unfreezeGraph } from "./common/trigger";

export default {
  name: "IdeaX6Flow",
  props: ["jobFlowInfo","collectJobList","readonly"],
  components: {
    NodesBar,
    PanelArea,
    Toolbar,
  },
  data() {
    return {
      graph: {},
      nodes,
      datajobNodes,
      datacollectNodes,
      type: 'grid',
      node: {},
      tooltipsContent: null,
      childShow: true,
    };
  },
  computed: {
    // 可操作去插槽
    panelAreaName() {
      return Config.PANEL_AREA_SLOT;
    },
  },
  watch: {
    graph() { 
    }
  },
  methods: {
    initListenerCustomEvent() {
      Channel.eventListener(
        CustomEventTypeEnum.TOOLTIPS_CALLBACK,
        (content) => (this.tooltipsContent = content)
      );
      Channel.eventListener(
        CustomEventTypeEnum.BLANK_CLICK, () => { 
          this.type = 'grid'
       });
      // emit 节点单击
      Channel.eventListener(CustomEventTypeEnum.NODE_CLICK, (detail) => {
        this.type = 'node'
        this.node = detail
        this.$emit("node-click", detail)
      });
      // emit 节点删除
      Channel.eventListener(CustomEventTypeEnum.NODE_REMOVE, (detail) => {
        this.type = 'node'
        this.node = detail
        this.$emit("node-remove", detail)

        // deleteCells(this.graph)
      });
      // emit 节点双击
      Channel.eventListener(CustomEventTypeEnum.DOUBLE_NODE_CLICK, (detail) =>
        this.$emit("node-dblclick", detail)
      );
      // emit 任务流程提交
      Channel.eventListener(CustomEventTypeEnum.FLOW_SUBMIT, (detail) =>
        this.$emit("flow-submit", detail)
      );
    },
  },
  created() {
  },
  mounted() {
    // 注册节点
    // registerNode();
    // 注册工具
    registerTools();
    // 实例化x6
    this.graph = initGraph();
    // 监听
    this.initListenerCustomEvent();
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
.graph-container {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .nodePanel {
    flex-basis: 260px;
    width: 260px;
    min-width: 260px;
    max-height: calc(100vh - 48px);
    border: 1px solid rgba(0, 0, 0, 0.08);
    background-color: #f7f9fb;
  }

  .editPanel {
    flex-grow: 1;
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    overflow: hidden;
    flex-direction: row;

    .dagCanvas {
      flex-grow: 1;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;

      .canvasToolbar {
        border: 1px solid rgba(0, 0, 0, 0.08);
        background-color: #f7f9fb;
      }
      
      .canvasContent {
        width: 100%;
        height: 100%;
        flex: 1;
        overflow: hidden;
        background-color: #f7f7fa;
        position: relative;
      }
    }
    
    .confPanel {
      width: 260px;
      min-width: 260px;
      flex: 1;
    }

    // tooltip
    #tooltip-container {
      // 禁止被双击||ctrl a选中
      user-select: none;
      border: 1px solid #e2e2e2;
      border-radius: 4px;
      font-size: 12px;
      color: #545454;
      width: 300px;
      word-break: break-all;
      background-color: rgba(255, 255, 255, 0.9);
      // padding: 10px 8px;
      box-shadow: rgb(174, 174, 174) 0px 0px 10px;
      position: absolute;
      z-index: 1;
      display: none;
      padding: 10px;
    }
  }
}

.x6-node {
  [magnet="true"] {
    cursor: crosshair;
    transition: none;

    &[port-group="in"] {
      cursor: move;
    }
  }

  .x6-port-body {
    visibility: hidden;
  }
}

// 选中后样式加粗标识
.begin-node-selected {
  ellipse {
    fill: #7aa4f7;
    stroke-width: 2;
  }
}

.condition-node-selected {
  rect {
    fill: #7aa4f7;
    stroke-width: 2;
  }
}

.tail-node-selected {
  rect {
    fill: #7aa4f7;
    stroke-width: 2;
  }
}

// 连接点交互
circle[data-class="choice-point"]:hover {
  transition: all 0.05s;
  r: 9;
}

</style>
